angular.module 'zc.core'

.filter "zcCurrency", ($filter) ->
  (currency, symbol, fractionSize, suffix) ->

    # currency is multiplied by a power of 10 that ensures the precision
    currency = currency / (10 ** fractionSize)

    string = $filter('currency')(currency, symbol, fractionSize)
    string += suffix if suffix
    string



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/zc_currency.coffee